import { Check, ChevronLeft, ChevronRight } from 'lucide-react';

const STEPS = [
  { id: 1, label: 'Wrap Up Today' },
  { id: 2, label: 'Process Inbox' },
  { id: 3, label: 'Plan Tomorrow' },
  { id: 4, label: 'Prep 1:1s' }
];

export default function PlanningWizard({
  currentStep,
  onStepChange,
  onFinish,
  canAdvance = true,
  inboxCount = 0,
  processedCount = 0
}) {
  const handleNext = () => {
    if (currentStep < STEPS.length) {
      onStepChange(currentStep + 1);
    } else {
      onFinish();
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      onStepChange(currentStep - 1);
    }
  };

  const currentLabel = STEPS[currentStep - 1]?.label;

  return (
    <div className="flex items-center gap-3 px-4 py-2.5 bg-surface-card border-b border-border">
      {/* Back button */}
      <button
        onClick={handleBack}
        disabled={currentStep === 1}
        className={`
          p-1.5 rounded-lg transition-all border-none cursor-pointer
          ${currentStep === 1
            ? 'text-text-muted cursor-not-allowed bg-transparent'
            : 'text-text-secondary hover:text-text-primary hover:bg-surface-hover'
          }
        `}
      >
        <ChevronLeft size={18} />
      </button>

      {/* Step dots */}
      <div className="flex items-center gap-1.5">
        {STEPS.map((step, index) => (
          <div key={step.id} className="flex items-center">
            <button
              onClick={() => step.id <= currentStep && onStepChange(step.id)}
              disabled={step.id > currentStep}
              className={`
                w-6 h-6 rounded-full flex items-center justify-center text-xs font-semibold
                transition-all duration-200 border-none cursor-pointer
                ${step.id < currentStep
                  ? 'bg-success text-white'
                  : step.id === currentStep
                    ? 'bg-accent text-white'
                    : 'bg-surface-hover text-text-muted cursor-not-allowed'
                }
              `}
            >
              {step.id < currentStep ? (
                <Check size={12} strokeWidth={3} />
              ) : (
                step.id
              )}
            </button>
            {index < STEPS.length - 1 && (
              <div className={`w-4 h-0.5 mx-0.5 rounded-full ${
                step.id < currentStep ? 'bg-success' : 'bg-border'
              }`} />
            )}
          </div>
        ))}
      </div>

      {/* Current step label */}
      <span className="text-sm font-medium text-text-primary">
        {currentLabel}
      </span>

      {/* Progress indicator for inbox step */}
      {currentStep === 2 && inboxCount > 0 && (
        <span className="text-xs text-text-tertiary bg-surface-hover px-2 py-0.5 rounded-full">
          {processedCount}/{processedCount + inboxCount}
        </span>
      )}

      {/* Spacer */}
      <div className="flex-1" />

      {/* Next/Finish button */}
      <button
        onClick={handleNext}
        disabled={!canAdvance}
        className={`
          flex items-center gap-1 px-3 py-1.5 rounded-lg text-sm font-medium
          transition-all duration-200 border-none cursor-pointer
          ${canAdvance
            ? 'bg-accent text-white hover:bg-orange-hover'
            : 'bg-surface-hover text-text-muted cursor-not-allowed'
          }
        `}
      >
        {currentStep === STEPS.length ? 'Finish' : 'Next'}
        {currentStep < STEPS.length && <ChevronRight size={16} />}
      </button>
    </div>
  );
}
